import { render, staticRenderFns } from "./menu-primary.vue?vue&type=template&id=6e5b4fbe&scoped=true&"
import script from "./menu-primary.vue?vue&type=script&lang=js&"
export * from "./menu-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b4fbe",
  null
  
)

export default component.exports